import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ProgressBar } from './ProgressBar/index.ts';
import { ProgressDate } from './ProgressDate/index.ts';
import styles from './SeasonProgress.module.scss';
export const SeasonProgress = ({ className, startDate, endDate, size })=>{
    const { seasonTimeRemaining, progress } = useMemo(()=>{
        if (!startDate || !endDate) return {
            seasonTimeRemaining: undefined,
            progress: undefined
        };
        const totalSeasonLength = endDate.getTime() - startDate.getTime();
        const timeRemaining = endDate.getTime() - new Date().getTime();
        return {
            seasonTimeRemaining: timeRemaining,
            progress: (totalSeasonLength - timeRemaining) / totalSeasonLength * 100
        };
    }, [
        startDate,
        endDate
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.seasonProgressContainer, className),
        "data-testid": "leaderboard-season-progress"
    }, /*#__PURE__*/ React.createElement(ProgressDate, {
        seasonTimeRemaining: seasonTimeRemaining
    }), /*#__PURE__*/ React.createElement(ProgressBar, {
        progress: progress,
        size: size
    }));
};
